"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _core = _interopRequireDefault(require("../../utils/core"));

var _class = _interopRequireDefault(require("../../utils/class"));

_core["default"].RichTextEditor = {
  Controls: [],
  Control: _class["default"].extend({
    types: null,
    text_tooltip: null,
    shortcut: {},
    init: _core["default"].noop,
    render: _core["default"].noop,
    exec: _core["default"].noop,
    refresh: _core["default"].noop,
    destroy: _core["default"].noop
  })
};